import Skeleton from '@/components/Skeleton';
import { twJoin } from 'tailwind-merge';

export function TableLoader() {
  const columns = Array.from({ length: 5 }, (_, i) => `Column ${i + 1}`);
  const rows = Array.from({ length: 10 }, (_, i) => `Row ${i + 1}`);

  return (
    <div className="w-full">
      <div className="rounded-lg border-0.5 border-ai-gray-400 bg-white overflow-hidden">
        <div className="grid grid-cols-5 gap-0">
          {columns.map((_, index) => (
            <div
              key={index}
              className={twJoin(
                'border-ai-gray-400 px-3 py-2.5 bg-pv-primary-primary-50',
                index !== 0 && 'border-l-0.5',
                index !== columns.length - 1 && 'border-r-0.5'
              )}
            >
              <Skeleton
                width={'70%'}
                height="19px"
                className="bg-brand-ai-gray-400 rounded-md"
              />
            </div>
          ))}
        </div>
        {rows.map((_, rowIndex) => (
          <div key={rowIndex} className="grid grid-cols-5 gap-0">
            {columns.map((_, colIndex) => (
              <div
                key={colIndex}
                className={twJoin(
                  'border-t-0.5 border-b-0.5 border-ai-gray-400 px-3 py-2.5 bg-white',
                  colIndex !== 0 && 'border-l-0.5',
                  colIndex === 0 && 'border-r-0.5',
                  colIndex !== columns.length - 1 && ' border-r-0.5'
                )}
              >
                <Skeleton
                  width={rowIndex % 2 === 0 ? '50%' : '70%'}
                  height="19px"
                  className="bg-brand-ai-gray-400 rounded-md"
                />
              </div>
            ))}
          </div>
        ))}
        <div className="h-10 flex items-center px-4 bg-white relative z-[1] justify-between">
          <Skeleton
            width="60px"
            height="19px"
            className="bg-brand-ai-gray-400 rounded-md"
          />
          <Skeleton
            width="100px"
            height="19px"
            className="bg-brand-ai-gray-400 rounded-md"
          />
        </div>
      </div>
      <div className="h-9 px-4 flex items-center">
        <div className="flex items-center gap-4">
          {Array.from({ length: 5 }, () => 1).map(() => (
            <Skeleton
              width="60px"
              height="19px"
              className="bg-brand-ai-gray-400 rounded-md"
            />
          ))}
        </div>
        <Skeleton
          width="80px"
          height="19px"
          className="bg-brand-ai-gray-400 rounded-md ml-auto"
        />
        <Skeleton
          width="20px"
          height="19px"
          className="bg-brand-ai-gray-400 rounded-md mx-4"
        />
        <Skeleton
          width="20px"
          height="19px"
          className="bg-brand-ai-gray-400 rounded-md mr-4"
        />
        <Skeleton
          width="20px"
          height="19px"
          className="bg-brand-ai-gray-400 rounded-md"
        />
      </div>
    </div>
  );
}
